import React from 'react';
import {Grid, Row, Col} from 'react-bootstrap';
import { PagePanel } from '../../../components/helpers/PagePanel';
import '../Home.css'
import {ExternalLink} from "../../../components/helpers/EasyLinks";
import {showCFP} from "../../../config";

const About = () => (
    <PagePanel className="transparent information">
        <Grid>
            <Row>
                <Col xs={12} sm={8} smPush={2}>
                    <h1>The Conference</h1>
                    <p className="lead"><strong>GR8Conf and JDK IO</strong> have joint <strong>forces</strong></p>
                    <p className="lead">
                      For the past 11 years, GR8Conf has provided a high-quality conference experience for the
                      tight-knit Apache Groovy programming language community. This year, we are joining forces with
                      JDK IO - an annual conference run by the Danish Java user group covering technologies relevant to
                      the entire JVM. The combined conference will be known as GR8Conf & JDK IO and will focus on All
                      Things Groovy and Java, with DevOps, Microservices and Frontend Technologies sprinkled in.
                    </p>
                </Col>
                <Col xs={12} sm={8} smPush={2}>
                    <h1>Where and When</h1>
                    <p className="lead">Join us for <strong>three awesome</strong> conference days, mixed with
                        <strong> workshops</strong>, at the <strong>IT-University of Copenhagen </strong>
                        from <strong>June 2nd</strong> to <strong>4th</strong>, 2020.</p>

                    <p className="lead">Your source for <strong>All Things Groovy and Java!</strong></p>
                </Col>
                {showCFP && <Col xs={8} xsPush={2}>
                    <h1>The Call for Propsals is open!</h1>
                    <p className="lead">Go to <ExternalLink link="https://cfp.gr8conf.org">cfp.gr8conf.org</ExternalLink> and
                        submit your proposal(s) for GR8Conf & JDK IO 2020 and be part of the awesome speakers line-up!</p>
                </Col>}
            </Row>
        </Grid>
    </PagePanel>);

export default About;



// WEBPACK FOOTER //
// ./src/pages/home/fragments/About.js